
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { dateToString } from './../../../nmb/util';

@Component({
  components: { }
})
export default class ProductNoticeList extends Vue {
  dateToString: Function = dateToString;

  @Prop() type: string;
  @Prop() noticeList: Array<{[key: string]: any}>;

  onClick(id: number) {
    this.$router.push( {path: `/home/noticeDetail/${id}`} );
  }
}
